import { SpecificNews } from '@sorare/gameplay/src/components/activity/SpecificNews';

const ActivityNewsShow = () => {
  return <SpecificNews />;
};

export default ActivityNewsShow;
